<template>
  <div>
    <div class="status search">
      <div class="field_left">
        <app-input
                inputClass="search"
                id="vyhledavani"
                name="search"
                :label="translations.search"
                inputSize="30"
                type="search"
                v-model="params.search"
        />
      </div>
      <a
        class="add add_expand"
        :class="{'open': isOpen}"
        @click.prevent="toggleExpandContent"
        title="Přidat synonymum"
      >Přidat synonymum</a>
    </div>

    <form class="filter expand_content" :class="{ 'open': isOpen }" @submit.prevent="submitForm">
      <div class="field_left">
        <app-input
          name="synonyms"
          :label="translations.synonym"
          :error="errors.items.find(el => el.field === 'synonyms')"
          v-model="synonym"
        />
      </div>

      <div class="field_right">
        <p class="field">
          <app-content-save-button :disabled="createDisabled" />
        </p>
      </div>
    </form>
  </div>
</template>

<script>
import { AUTOCOMPLETE_TITLE } from "symbols/autocomplete"
import { mapActions, mapState } from "vuex"
import apiMessagesMixin from '../../mixins/apiMessagesMixin'

export default {
  name: "templates-search-bar",
  mixins: [
    apiMessagesMixin
  ],
  props: {
    params: {
      type: Object,
      default: () => ({})
    },
    createDisabled: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      synonym: "",
      isOpen: false,
      apiErrors: {}
    };
  },
  computed: {
    ...mapState({
      currentLanguage: state => state.uiLanguages.currentLanguage
    }),
    translations() {
      return {
        search: this.$gettext('Vyhledávání'),
        synonym: this.$gettext('Synonumum *'),
        usedSynonym: this.$gettext('Synonymum je již použito'),
        synonymWithComa: this.$gettext('Synonymum nesmí obsahovat čárku'),
        emptySynonym: this.$gettext('Synonymum nesmí být prázdné')
      }
    }
  },
  methods: {
    ...mapActions([
      'updateCountry',
      'appShowErrors',
      'appClearErrors'
    ]),
    async submitForm(e) {
      if (this.item.synonyms) {
        if (this.item.synonyms.indexOf(this.synonym)>=0) {
          this.appShowErrors([this.translations.usedSynonym])
          return
        }
      }
      if (this.synonym.includes(',')) {
        this.appShowErrors([this.translations.synonymWithComa])
        return
      }
      if (this.synonym === "") {
        this.appShowErrors([this.translations.emptySynonym])
        return
      }

      let obj = {...this.item}
      if (obj.synonyms === null) {
        obj.synonyms = []
      }

      obj.synonyms = obj.synonyms.concat(this.synonym)

      const result = await this.updateCountry({
        params: {
          id: this.item._id
        },
        data: obj
      }).catch(err => err.response)

      this.handleResponseIfError(result)

      if (result.status === 200) {
        e.target.reset();
        this.$validator.reset();
      }
    },
    handleResponseIfError(response) {
        if (response.status === 500) {
          this.appShowErrors([this.errorTrans.serverError])
        }

        if (response.status === 422) {
          this.appShowErrors([this.apiMessagesMap.synonymMustBeUnique])
        }

        this.apiErrors = response.data.error
        if (this.apiErrors && this.apiErrors.length) {
          this.mapApiErrorsToErrors()

          if (response.status === 422) {
            this.appShowErrors([this.errorTrans.formError])
          }
        }
      },
    toggleExpandContent() {
      this.isOpen = !this.isOpen;
    },
    mapApiErrorsToErrors() {
      this.errors.add(this.apiErrors.map(v => ({ field: v.path, msg: this.translateMsg(v.message) })))
    }
  },
  watch: {
    currentLanguage() {
      if (this.errors.items.length) {
        this.errors.clear()
        this.mapApiErrorsToErrors()
        this.appClearErrors()
      }
    }
  }
}
</script>
